"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverrideQueryString = exports.addQueryString = void 0;
/* eslint-disable no-undef */
const addQueryString = (query, value) => {
    if (!window.location) {
        return null;
    }
    const { origin, pathname, search } = window.location;
    const searchParams = new URLSearchParams(search);
    searchParams.set(query, value);
    return `${origin}${pathname}?${searchParams.toString()}`;
};
exports.addQueryString = addQueryString;
const getOverrideQueryString = (flags) => {
    const queryString = Object.entries(flags).map((entry) => entry.join('~')).join(',');
    return queryString;
};
exports.getOverrideQueryString = getOverrideQueryString;
//# sourceMappingURL=link-generation.js.map